export const SET_PAGE_BEFORE_STEPS = 'SET_PAGE_BEFORE_STEPS';

// This sets where the 'back' button should lead to on the "Steps to File" first page
// Should either be the results page, the pre-check page, or none (hide the back button)
export const setPageBeforeSteps = (pageBeforeSteps) => {
  return { type: SET_PAGE_BEFORE_STEPS, payload: pageBeforeSteps };
}